import _extends from '@babel/runtime/helpers/extends';
import { forwardRef, omitThemingProps, useMultiStyleConfig, StylesProvider, chakra } from '@chakra-ui/react';
import { cx } from '@chakra-ui/utils';
import * as React from 'react';

/**
 * Card
 *
 * React component used to display information in a box-ed in card-like layout.
 */
var Card = forwardRef(function (props, ref) {
  var rest = omitThemingProps(props);
  var styles = useMultiStyleConfig('Card', props);
  return /*#__PURE__*/React.createElement(StylesProvider, {
    value: styles
  }, /*#__PURE__*/React.createElement(chakra.div, _extends({
    ref: ref
  }, rest, {
    className: cx('chakra-card', props.className),
    __css: styles.card
  })));
});
Card.displayName = 'Card';
export { Card };